import React from "react";
import { createRoot } from "react-dom/client"; // Import createRoot
import App from "./App";
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";
import { BrowserRouter } from "react-router-dom";
import { UIContextProvider } from "./providers/UIProvider";
import SnackbarAlert from "./components/snackbarAlert";

/**
 * Initialize a PublicClientApplication instance which is provided to the MsalProvider component
 * We recommend initializing this outside of your root component to ensure it is not re-initialized on re-renders
 */
// @ts-ignore
export const msalInstance = new PublicClientApplication(msalConfig);

// Clear My Applications, Review and Action filter caches on every successful login
// so that users always get records for all quarters/years by default when they log in, 
// instead of potentially stale filters from a previous session
msalInstance.addEventCallback((event) => {
  if (
    event.eventType === EventType.LOGIN_SUCCESS
  ) {
    localStorage.removeItem("search_filters_action_items");
    localStorage.removeItem("search_filters_review");
    localStorage.removeItem("search_filters_my_applications");
    }
});

// Get the container DOM element to pass to createRoot
const container = document.getElementById("root");
// @ts-ignore
const root = createRoot(container); // Create a root.

root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <BrowserRouter>
        <UIContextProvider>
          <SnackbarAlert />
          <App />
        </UIContextProvider>
      </BrowserRouter>
    </MsalProvider>
  </React.StrictMode>
);
